export const EDESENV = '/edesenv';
